import { render, staticRenderFns } from "./CreateCoupon.vue?vue&type=template&id=1ae3deb8&scoped=true&"
import script from "./CreateCoupon.vue?vue&type=script&lang=js&"
export * from "./CreateCoupon.vue?vue&type=script&lang=js&"
import style0 from "./CreateCoupon.vue?vue&type=style&index=0&id=1ae3deb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae3deb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ae3deb8')) {
      api.createRecord('1ae3deb8', component.options)
    } else {
      api.reload('1ae3deb8', component.options)
    }
    module.hot.accept("./CreateCoupon.vue?vue&type=template&id=1ae3deb8&scoped=true&", function () {
      api.rerender('1ae3deb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Brand/CreateCoupon.vue"
export default component.exports